module.exports = __webpack_public_path__ + "img/program-background.ee0aaea9.png";